import {action, observable, computed} from 'mobx';
import {  getDeviceList, getDeviceInfo } from '@/services/Home';
import BaseStore from '@/stores/base';
import UserStore from '@/stores/user';

export interface DeviceInfoProps {
  /** 异常设备数量 */
  abnormal: number;
  /** 将要过期设备数量 */
  willExpire: number;
  /** 开通ip代理设备数量 */
  openedIpAgent: number;
  /** 开通一键新机设备数量 */
  openedOneClickNewMachine: number;
}

class DeviceBaseStore {

  @observable.ref deviceList: any[] = [];

  @observable selectedCids: string  [] = [];
  
  @observable deviceInfo: DeviceInfoProps = {
    abnormal: 0,
    willExpire: 0,
    openedIpAgent: 0,
    openedOneClickNewMachine: 0
  }

  @computed get selectedCidsAmount() {
    return this.selectedCids.length;
  }
  
  @computed get deviceListLen(): number{
    return this.deviceList.length
  }
  
  @action.bound async getDeviceList (params: {groupId: number | string | string[]}) {

    const [error, result] = await getDeviceList(params);

    if (error) return;
    
    if (!result.groupDeviceList) {
      this.deviceList = []
      return
    }
    this.deviceList = result.groupDeviceList

  }
  
  @action.bound async getDeviceInfo (id?: string | number) {
    
    const [error , result] = await getDeviceInfo({
      roomId: id || BaseStore.RoomStore.activeRoom.id,
      groupId: UserStore.GroupStore.activeGroupId || undefined
    });
    
    if (error) return;
    
    const {roomInfo,groupInfo} = result;
    
    this.deviceInfo = {
      abnormal: roomInfo.errorCount,
      willExpire:roomInfo.expireCount,
      openedIpAgent: groupInfo.buyIpCount,
      openedOneClickNewMachine: groupInfo.newPhoneCount
    }
    
  }

  @action.bound setCids (cids: string []) {
    
    this.selectedCids = cids
    
  }
  
  @action.bound setDeviceList (list: any []) {
    
    this.deviceList = list
    
  }
  
  @action.bound setDeviceInfoInit () {
  
    this.deviceInfo = {
      abnormal: 0,
      willExpire: 0,
      openedIpAgent: 0,
      openedOneClickNewMachine: 0
    }
    
  }

}

export default DeviceBaseStore;
